/**
 * One-time language migration
 * 
 * Migrates users who have 'en' in localStorage to 'nl' (NL-first strategy),
 * UNLESS they explicitly chose EN (source=user marker).
 * 
 * This migration runs once per browser and sets a flag to prevent re-running.
 */

const MIGRATION_KEY = 'i18n-migration-v1-nl-first';
const LANG_KEY = 'i18nextLng';
const SOURCE_KEY = 'i18nextLngSource'; // Consistent with LanguageSwitch.tsx

export function runLanguageMigration(): void {
  // Check if migration already ran
  if (localStorage.getItem(MIGRATION_KEY) === 'done') {
    return;
  }

  const currentLang = localStorage.getItem(LANG_KEY);
  const source = localStorage.getItem(SOURCE_KEY);
  // Also check legacy key format
  const legacySource = localStorage.getItem('i18nextLng-source');

  // Only migrate if:
  // 1. Current language is 'en'
  // 2. User did NOT explicitly choose it (source !== 'user')
  if (currentLang === 'en' && source !== 'user' && legacySource !== 'user') {
    // Silent migration - no console output in production
    localStorage.setItem(LANG_KEY, 'nl');
    // Don't set source - this is a system migration, not user choice
  }

  // Mark migration as complete
  localStorage.setItem(MIGRATION_KEY, 'done');
}

/**
 * Call this when user explicitly changes language via LanguageSwitch
 * This protects their choice from future migrations
 */
export function markLanguageAsUserChoice(lang: string): void {
  localStorage.setItem(LANG_KEY, lang);
  localStorage.setItem(SOURCE_KEY, 'user');
}
